import { Component, Input } from '@angular/core';
import { MeetingType } from 'Angular/src/app/shared/model';

@Component({
  selector: 'app-radio-button',
  templateUrl: './contact-radio-button.component.html',
  styleUrls: ['./contact-radio-buttons.component.css']
})
export class ContactRadioButtonsComponent {
  @Input() default = MeetingType.Teams;

  constructor() {
   }

  getChecked(id: string): boolean {
   return Number(this.default) === Number(id);
  }
}
